export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";